import { sort } from 'fast-sort'
const indicators = [
	{
		"TitleQuestion": "Anexe o aceite",
		"Code_R": "EVIDACEITE",
		"Dimensão": "Social",
		"Tema": "Tecnologia",
		"Indicador": "Considera ter ou não acesso a tecnologia",
		"Fonte": "9-c-1 - Proporção da população coberta por rede móvel, por tipo de tecnologia ",
		"ODS": "9-Indústria, Inovação e Infraestrutura"
	},
	{
		"TitleQuestion": "Anexe a dica",
		"Code_R": "EVID",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Descreva a dica",
		"Code_R": "DICADESCRITO",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Mais alguém estava presente?",
		"Code_R": "EVIDVISITA",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Descrição do treinamento",
		"Code_R": "DESCRICAOCAPACITACAO",
		"Dimensão": "Social",
		"Tema": "Educação",
		"Indicador": "Realizou capacitações técnicas relacionadas à produção no último ano.",
		"Fonte": "4.3.1 - Taxa de participação de jovens e adultos na educação formal e não formal, nos últimos 12 meses, por sexo",
		"ODS": "4-Educação de qualidade"
	},
	{
		"TitleQuestion": "Nota do treinamento",
		"Code_R": "NOTA",
		"Dimensão": "Social",
		"Tema": "Educação",
		"Indicador": "Considera nota relacionada ao acesso a Capacitação",
		"Fonte": "4.3.1 - Taxa de participação de jovens e adultos na educação formal e não formal, nos últimos 12 meses, por sexo",
		"ODS": "4-Educação de qualidade"
	},
	{
		"TitleQuestion": "Quem estava presente na visita?",
		"Code_R": "EVIDVISITA",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Como você julga que seu conhecimento sobre a cultura principal do projeto aumentou desde o início da assistência técnica prestada pela ManejeBem? ",
		"Code_R": "EVIDRELATO",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "ManejeBem - Nota do Produtor",
		"Code_R": "NOTA",
		"Dimensão": "",
		"Tema": "",
		"Indicador": "",
		"Fonte": "",
		"ODS": ""
	},
	{
		"TitleQuestion": "Beta ácidos – n-+Adlupulona (g\/100 g) - Desvio padrão",
		"Code_R": "ADLUGDESVIOLUPULO",
		"Dimensão": "Produção",
		"Tema": "Manejo Vegetal",
		"Indicador": "Considera se efetua ou não analise",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Beta ácidos – Colupulona (g\/100 g) - Desvio padrão",
		"Code_R": "COLUGDESVIOLUPULO",
		"Dimensão": "Produção",
		"Tema": "Manejo Vegetal",
		"Indicador": "Considera se efetua ou não analise",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Alfa ácidos – n-+Adhumulona (g\/100 g) - Desvio padrão",
		"Code_R": "ADHUDESVLUPULO",
		"Dimensão": "Produção",
		"Tema": "Manejo Vegetal",
		"Indicador": "Considera se efetua ou não analise",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Alfa ácidos – Cohumulona (g\/100 g) - Desvio padrão",
		"Code_R": "COHUGDESVLUPULO",
		"Dimensão": "Produção",
		"Tema": "Manejo Vegetal",
		"Indicador": "Considera se efetua ou não analise",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Se julgar necessário, descreva a manutenção recomendada ao agricultor",
		"Code_R": "DESCREVERECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Manutenção - Nota do Agricultor",
		"Code_R": "NOTA",
		"Dimensão": "",
		"Tema": "",
		"Indicador": "",
		"Fonte": "",
		"ODS": ""
	},
	{
		"TitleQuestion": "Quais recomendações relacionadas à manutenção foram dadas ao produtor?",
		"Code_R": "RECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Você deseja reportar alguma inadequação na manutenção do produtor?",
		"Code_R": "INAD",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Sobre qual tipo de manutenção você prestou atendimento?",
		"Code_R": "MANUTENCAOTIPO",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Beta ácidos – n-+Adlupulona (%, m\/m)",
		"Code_R": "ADLUPORLUPULO",
		"Dimensão": "Produção",
		"Tema": "Manejo Vegetal",
		"Indicador": "Considera se efetua ou não analise",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Beta ácidos – n-+Adlupulona (g\/100 g)",
		"Code_R": "ADLUGLUPULO",
		"Dimensão": "Produção",
		"Tema": "Manejo Vegetal",
		"Indicador": "Considera se efetua ou não analise",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Beta ácidos – Colupulona (%, m\/m)",
		"Code_R": "COLUPUPORLUPULO",
		"Dimensão": "Produção",
		"Tema": "Manejo Vegetal",
		"Indicador": "Considera se efetua ou não analise",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Beta ácidos – Colupulona (g\/100 g)",
		"Code_R": "COLUPUGLUPULO",
		"Dimensão": "Produção",
		"Tema": "Manejo Vegetal",
		"Indicador": "Considera se efetua ou não analise",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Alfa ácidos – n-+Adhumulona (%, m\/m)",
		"Code_R": "ADHUPORLUPULO",
		"Dimensão": "Produção",
		"Tema": "Manejo Vegetal",
		"Indicador": "Considera se efetua ou não analise",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Alfa ácidos – n-+Adhumulona (g\/100 g)",
		"Code_R": "ADHUGLUPULO",
		"Dimensão": "Produção",
		"Tema": "Manejo Vegetal",
		"Indicador": "Considera se efetua ou não analise",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Alfa ácidos – Cohumulona (%, m\/m)",
		"Code_R": "COHUPORCLUPULO",
		"Dimensão": "Produção",
		"Tema": "Manejo Vegetal",
		"Indicador": "Considera se efetua ou não analise",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Alfa ácidos – Cohumulona (g\/100 g)",
		"Code_R": "COHUGLUPULO",
		"Dimensão": "Produção",
		"Tema": "Manejo Vegetal",
		"Indicador": "Considera se efetua ou não analise",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Se julgar necessário, descreva a orientação recomendada ao produtor",
		"Code_R": "DESCEVERECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Quais recomendações relacionadas à certificação foram dadas ao produtor?",
		"Code_R": "RECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Você deseja reportar alguma inadequação nas certificações do produtor?",
		"Code_R": "INAD",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "O produtor efetua análise de solo?",
		"Code_R": "ANALISEDESOLO",
		"Dimensão": "Produção",
		"Tema": "Manejo Vegetal",
		"Indicador": "Considera se efetua ou não analise",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Qual o manejo realizado na propriedade para o controle de doenças e pragas?",
		"Code_R": "MANEJOS",
		"Dimensão": "Ambiental",
		"Tema": "Manejo",
		"Indicador": "Manejo sustentável ou não (Corte e queima, Convencional com\/sem orientação técnica, Transição agroecológica e Agroecológico)",
		"Fonte": "2.4.1 - Proporção da área agrícola sob agricultura produtiva e sustentável",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "O agricultor efetua correção do solo?",
		"Code_R": "CORRECAODESOLO",
		"Dimensão": "Produção",
		"Tema": "Manejo Vegetal",
		"Indicador": "Considerar se efetua ou não correção",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Qual o preparo do solo é efetuado pelo produtor?",
		"Code_R": "PREPAROSOLO",
		"Dimensão": "Produção",
		"Tema": "Preparo do Solo",
		"Indicador": "Considerar se efetua ou não preparo do solo",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Qual adubação o produtor realiza?",
		"Code_R": "ADUBACAOTIPO",
		"Dimensão": "Produção",
		"Tema": "Manejo Vegetal",
		"Indicador": "Varia entre química - com\/sem análise de solo; verde\/natural\/orgânica\/agroecológica com\/sem orientação técnica",
		"Fonte": "2.4.1 - Proporção da área agrícola sob agricultura produtiva e sustentável",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Gestão da propriedade",
		"Code_R": "GESTAOFIN",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Digite a renda bruta mensal obtida de fora da produção (renda extra)",
		"Code_R": "RENDAEXTRA",
		"Dimensão": "Econômica",
		"Tema": "Renda Familiar",
		"Indicador": "Calculado (Preço médio * produção total) \/ 12 e % em relação ao salario mínimo ideal do DIEESE do ano anterior)",
		"Fonte": "1-1-1 - Proporção da população vivendo abaixo da linha de pobreza internacional, por sexo, idade, condição perante o trabalho e localização geográfica (urbano\/rural) ",
		"ODS": "1-ERRADICAÇÃO DA POBREZA"
	},
	{
		"TitleQuestion": "Digite a renda bruta mensal obtida com a produção",
		"Code_R": "RENDAMENSAL",
		"Dimensão": "Econômica",
		"Tema": "Renda Familiar",
		"Indicador": "Calculado (Preço médio * produção total) \/ 12 e % em relação ao salario mínimo ideal do DIEESE do ano anterior)",
		"Fonte": "1-1-1 - Proporção da população vivendo abaixo da linha de pobreza internacional, por sexo, idade, condição perante o trabalho e localização geográfica (urbano\/rural) ",
		"ODS": "1-ERRADICAÇÃO DA POBREZA"
	},
	{
		"TitleQuestion": "Potabilidade\/Tratamento da água de consumo",
		"Code_R": "POTABILIDADEAGUA",
		"Dimensão": "Social",
		"Tema": "Saúde",
		"Indicador": "Portaria número 888 de 04\/05\/2021 do Ministério da Saúde dispõe sobre os procedimentos de controle e de vigilância da qualidade da água para consumo humano e seu padrão de potabilidade, na forma do Anexo XX da Portaria de Consolidação GM\/MS nº 5, de 28 de setembro de 2017.",
		"Fonte": "6-1-1 - Proporção da população que utiliza serviços de água potável gerenciados de forma segura ",
		"ODS": "6-Água potável e saneamento"
	},
	{
		"TitleQuestion": "Treinamentos efetuados ao longo do ano",
		"Code_R": "NUMEROCAPACITACOESANO",
		"Dimensão": "Social",
		"Tema": "Educação",
		"Indicador": "Realizou capacitações técnicas relacionadas à produção no último ano.",
		"Fonte": "4.3.1 - Taxa de participação de jovens e adultos na educação formal e não formal, nos últimos 12 meses, por sexo",
		"ODS": "4-Educação de qualidade"
	},
	{
		"TitleQuestion": "Destinos de embalagens (insumos, fertilizantes, agrotóxicos)",
		"Code_R": "DESTINOEMBALAGENS",
		"Dimensão": "Ambiental",
		"Tema": "Destino de Resíduos",
		"Indicador": "Tipo de destino dado ao lixo na propriedade. Quando houver dois tipos de tratamento, considerar o valor médio entre o limite anterior e o posterior da pior e da melhor condição, a média obtida definirá a base do calculo. ",
		"Fonte": "12-5-1 - Taxa de reciclagem nacional por toneladas de material reciclado ",
		"ODS": "12-Consumo e produção responsáveis"
	},
	{
		"TitleQuestion": "Uso de agrotóxicos",
		"Code_R": "USAAGROTOXICOS",
		"Dimensão": "Ambiental",
		"Tema": "Proteção a biodiversidade e corpos dágua",
		"Indicador": "Utiliza ou insumos químicos próximos a corpos d'água",
		"Fonte": "6-3-2: Proporção de corpos hídricos com boa qualidade ambiental ",
		"ODS": "6-Água potável e saneamento"
	},
	{
		"TitleQuestion": "Você deseja reportar alguma inadequação relacionada a piscicultura?",
		"Code_R": "INAD",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Quanto dessa renda vem da produção do lúpulo?",
		"Code_R": "RENDAAGRICOLA",
		"Dimensão": "Econômica",
		"Tema": "Renda Familiar",
		"Indicador": "Calculado (Preço médio * produção total) \/ 12 e % em relação ao salario mínimo ideal do DIEESE do ano anterior)",
		"Fonte": "1-1-1 - Proporção da população vivendo abaixo da linha de pobreza internacional, por sexo, idade, condição perante o trabalho e localização geográfica (urbano\/rural) ",
		"ODS": "1-ERRADICAÇÃO DA POBREZA"
	},
	{
		"TitleQuestion": "Você deseja reportar alguma inadequação na pós-colheita efetuada pelo agricultor?",
		"Code_R": "INAD",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Você deseja reportar alguma inadequação na colheita efetuada pelo agricultor?",
		"Code_R": "INAD",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Você deseja reportar alguma inadequação na tecnologia, equipamentos e maquinários efetuada pelo agricultor?",
		"Code_R": "INAD",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Você deseja reportar alguma inadequação na gestão financeira efetuada pelo agricultor?",
		"Code_R": "INAD",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Você deseja reportar alguma inadequação no manejo de plantas daninhas efetuado pelo agricultor?",
		"Code_R": "INAD",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Você deseja reportar alguma inadequação no manejo de doenças e pragas efetuado pelo agricultor?",
		"Code_R": "INAD",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Tema do conteúdo",
		"Code_R": "TEMACONTEUDO",
		"Dimensão": "Social",
		"Tema": "Educação",
		"Indicador": "Realizou capacitações técnicas relacionadas à produção no último ano.",
		"Fonte": "4.3.1 - Taxa de participação de jovens e adultos na educação formal e não formal, nos últimos 12 meses, por sexo",
		"ODS": "4-Educação de qualidade"
	},
	{
		"TitleQuestion": "Tema do conteúdo",
		"Code_R": "TEMACONTEUDO",
		"Dimensão": "",
		"Tema": "",
		"Indicador": "",
		"Fonte": "",
		"ODS": ""
	},
	{
		"TitleQuestion": "Tema do conteúdo",
		"Code_R": "TEMACONTEUDO",
		"Dimensão": "Cadastro",
		"Tema": "Plano de Ação",
		"Indicador": "",
		"Fonte": "",
		"ODS": ""
	},
	{
		"TitleQuestion": "Dicas agrônomicas - Nota do Agricultor",
		"Code_R": "NOTA",
		"Dimensão": "Social",
		"Tema": "Educação",
		"Indicador": "Considera nota relacionada ao acesso a Dica Agronômica",
		"Fonte": "4.3.1 - Taxa de participação de jovens e adultos na educação formal e não formal, nos últimos 12 meses, por sexo",
		"ODS": "4-Educação de qualidade"
	},
	{
		"TitleQuestion": "Descreva a dica agronômica dada ao produtor para melhorias na propriedade",
		"Code_R": "DICADESCRITO",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Selecione quais dicas agronômicas você enviou ao produtor",
		"Code_R": "DICATIPO",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Clima - Nota do Agricultor",
		"Code_R": "NOTA",
		"Dimensão": "",
		"Tema": "",
		"Indicador": "",
		"Fonte": "",
		"ODS": ""
	},
	{
		"TitleQuestion": "Se necessário, descreva a recomendação dada ao produtor para melhorias relacionadas ao clima",
		"Code_R": "DESCREVERECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Selecione sobre o que você prestou atendimento relacionado ao clima",
		"Code_R": "CLIMATIPO",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Acesso a Assistência Técnica",
		"Code_R": "TIPOASSISTEC",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Disponibilidade de energia elétrica",
		"Code_R": "ENERGIA",
		"Dimensão": "Social",
		"Tema": "Disponibilidade de energia elétrica",
		"Indicador": "Quando a propriedade dispõe de energia compartilhada do vizinho ou mesmo quando a energia é não oficial, considera-se que NÃO POSSUI ENERGIA ELÉTRICA",
		"Fonte": "",
		"ODS": ""
	},
	{
		"TitleQuestion": "Escolaridade do chefe da família",
		"Code_R": "ESCOLARIDADE",
		"Dimensão": "Social",
		"Tema": "Educação",
		"Indicador": "Varia de não alfabetizado a nivel superior completo. No caso de curso técnico considerar como ensimo médio.",
		"Fonte": "4.5 - Até 2030, eliminar as disparidades de gênero na educação e garantir a igualdade de acesso a todos os níveis de educação e formação profissional para os mais vulneráveis, incluindo as pessoas com deficiência, povos indígenas e as crianças em situação de vulnerabilidade",
		"ODS": "4-Educação de qualidade"
	},
	{
		"TitleQuestion": "Na propriedade, há uma área susceptível para instalação de uma fossa séptica?",
		"Code_R": "FOSSASEPTICA",
		"Dimensão": "Ambiental",
		"Tema": "Saneamento",
		"Indicador": "Tipo de instalação sanitária variando do insustentável (sem nenhum tipo de tratamento) ao sustentável (com tratamento)",
		"Fonte": "6-2-1 - Proporção da população que utiliza (a) serviços de saneamento gerenciados de forma segura e (b) instalações para lavagem das mãos com água e sabão ",
		"ODS": "6-Água potável e saneamento"
	},
	{
		"TitleQuestion": "Qual o sistema de esgotamento?",
		"Code_R": "SISTESGOTO",
		"Dimensão": "Ambiental",
		"Tema": "Saneamento",
		"Indicador": "Tipo de instalação sanitária variando do insustentável (sem nenhum tipo de tratamento) ao sustentável (com tratamento)",
		"Fonte": "6-2-1 - Proporção da população que utiliza (a) serviços de saneamento gerenciados de forma segura e (b) instalações para lavagem das mãos com água e sabão ",
		"ODS": "6-Água potável e saneamento"
	},
	{
		"TitleQuestion": "Quanto você ganha nessa comercialização? (R$)",
		"Code_R": "RENDACOMERCIALIZACAO",
		"Dimensão": "Econômica",
		"Tema": "Renda Familiar",
		"Indicador": "Calculado (Preço médio * produção total) \/ 12 e % em relação ao salario mínimo ideal do DIEESE do ano anterior)",
		"Fonte": "1-1-1 - Proporção da população vivendo abaixo da linha de pobreza internacional, por sexo, idade, condição perante o trabalho e localização geográfica (urbano\/rural) ",
		"ODS": "1-ERRADICAÇÃO DA POBREZA"
	},
	{
		"TitleQuestion": "Dos jovens (menores de 16 anos) que moram na mesma casa, quantos trabalham na atividade agrícola",
		"Code_R": "JOVENSNAATIVIDADE",
		"Dimensão": "Social",
		"Tema": "Inclusão",
		"Indicador": "Participação de jovens na produção",
		"Fonte": "8-6-1 - Percentagem de jovens (15-24) que não estão na força de trabalho (ocupados e não ocupados), não são estudantes e nem estão em treinamento para o trabalho ",
		"ODS": "8-Trabalho decente e crescimento econômico"
	},
	{
		"TitleQuestion": "Quantidade (Kg\/ha)",
		"Code_R": "INSUMOQUANTIDADE",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera se faz ou não controle",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Produtividade média final (Kg\/planta) ",
		"Code_R": "PRODUTIVIDADEMEDIAKGPLANTA",
		"Dimensão": "Econômica",
		"Tema": "Produção",
		"Indicador": "Produtividade (kg\/ha) em relação a média anual da região",
		"Fonte": "2.3.1 - Volume de produção por unidade de trabalho por dimensão da empresa agrícola\/pastoril\/florestal",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Quanto dessa renda familiar vem da atividade agrícola?",
		"Code_R": "RENDAAGRICOLA",
		"Dimensão": "Econômica",
		"Tema": "Renda Familiar",
		"Indicador": "Calculado (Preço médio * produção total) \/ 12 e % em relação ao salario mínimo ideal do DIEESE do ano anterior)",
		"Fonte": "1-1-1 - Proporção da população vivendo abaixo da linha de pobreza internacional, por sexo, idade, condição perante o trabalho e localização geográfica (urbano\/rural) ",
		"ODS": "1-ERRADICAÇÃO DA POBREZA"
	},
	{
		"TitleQuestion": "Qual a renda mensal bruta familiar?",
		"Code_R": "RENDAMENSAL",
		"Dimensão": "Econômica",
		"Tema": "Renda Familiar",
		"Indicador": "Calculado (Preço médio * produção total) \/ 12 e % em relação ao salario mínimo ideal do DIEESE do ano anterior)",
		"Fonte": "1-1-1 - Proporção da população vivendo abaixo da linha de pobreza internacional, por sexo, idade, condição perante o trabalho e localização geográfica (urbano\/rural) ",
		"ODS": "1-ERRADICAÇÃO DA POBREZA"
	},
	{
		"TitleQuestion": "Adicione aqui a evidência desse atendimento",
		"Code_R": "EVIDATEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Adicione aqui a evidência desse atendimento",
		"Code_R": "EVIDATEND",
		"Dimensão": "Social",
		"Tema": "Educação",
		"Indicador": "Realizou capacitações técnicas relacionadas à produção no último ano.",
		"Fonte": "4.3.1 - Taxa de participação de jovens e adultos na educação formal e não formal, nos últimos 12 meses, por sexo",
		"ODS": "4-Educação de qualidade"
	},
	{
		"TitleQuestion": "Adicione aqui a evidência desse atendimento",
		"Code_R": "EVIDATEND",
		"Dimensão": "",
		"Tema": "",
		"Indicador": "",
		"Fonte": "",
		"ODS": ""
	},
	{
		"TitleQuestion": "Selecione a unidade de medida para a quantidade de insumos utilizada na propriedade",
		"Code_R": "UNMEDIDAQUANTINSUMO",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Qual a quantidade de insumos é utilizado na propriedade por ano?",
		"Code_R": "QUANTIAINSUMOS",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "O produtor participa de treinamentos profissionais durante o ano? Se sim, quantos?",
		"Code_R": "NUMEROCAPACITACOESANO",
		"Dimensão": "Social",
		"Tema": "Educação",
		"Indicador": "Realizou capacitações técnicas relacionadas à produção no último ano.",
		"Fonte": "4.3.1 - Taxa de participação de jovens e adultos na educação formal e não formal, nos últimos 12 meses, por sexo",
		"ODS": "4-Educação de qualidade"
	},
	{
		"TitleQuestion": "Gestão Financeira - Foto do Caderno de Campo",
		"Code_R": "EVIDCADERNODECAMPO",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera usar ou não para Caderno de Campo",
		"Fonte": "4.3.1 - Taxa de participação de jovens e adultos na educação formal e não formal, nos últimos 12 meses, por sexo",
		"ODS": "4-Educação de qualidade"
	},
	{
		"TitleQuestion": "Possui produção assistida e\/ou visitada por técnico responsável credenciado ao RENASCEM ?",
		"Code_R": "RENASCEM",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Observação",
		"Code_R": "OBSERVACOES",
		"Dimensão": "Ambiental",
		"Tema": "Manejo",
		"Indicador": "Manejo sustentável ou não (Corte e queima, Convencional com\/sem orientação técnica, Transição agroecológica e Agroecológico)",
		"Fonte": "2.4.1 - Proporção da área agrícola sob agricultura produtiva e sustentável",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Observação",
		"Code_R": "OBSERVACOES",
		"Dimensão": "Produção",
		"Tema": "Sanidade Vegetal",
		"Indicador": "Presença ou não de doenças",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Referente à qual assunto você prestou atendimento sobre a ManejeBem?",
		"Code_R": "SUPOTEUSER",
		"Dimensão": "",
		"Tema": "",
		"Indicador": "",
		"Fonte": "",
		"ODS": ""
	},
	{
		"TitleQuestion": "Quanto você recebeu (faturamento) no último ano? (R$\/ano)",
		"Code_R": "FATURAMENTOANO",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "",
		"ODS": ""
	},
	{
		"TitleQuestion": "Qual adubação é efetuada pelo produtor?",
		"Code_R": "ADUBACAOTIPO",
		"Dimensão": "Produção",
		"Tema": "Manejo Vegetal",
		"Indicador": "Varia entre química - com\/sem análise de solo; verde\/natural\/orgânica\/agroecológica com\/sem orientação técnica",
		"Fonte": "2.4.1 - Proporção da área agrícola sob agricultura produtiva e sustentável",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Na visão do produtor, qual a principal problemática existente na sua produção?",
		"Code_R": "PROBLEMATICA",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Link para acesso ao treinamento (se houver):",
		"Code_R": "EVIDCAPACITACAO",
		"Dimensão": "Social",
		"Tema": "Educação",
		"Indicador": "Realizou capacitações técnicas relacionadas à produção no último ano.",
		"Fonte": "4.3.1 - Taxa de participação de jovens e adultos na educação formal e não formal, nos últimos 12 meses, por sexo",
		"ODS": "4-Educação de qualidade"
	},
	{
		"TitleQuestion": "Quantidade total de horas:",
		"Code_R": "CAPACITACAOQUANTHORAS",
		"Dimensão": "Social",
		"Tema": "Educação",
		"Indicador": "Realizou capacitações técnicas relacionadas à produção no último ano.",
		"Fonte": "4.3.1 - Taxa de participação de jovens e adultos na educação formal e não formal, nos últimos 12 meses, por sexo",
		"ODS": "4-Educação de qualidade"
	},
	{
		"TitleQuestion": "Utiliza caderno de campo?",
		"Code_R": "CADERNODECAMPO",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera usar ou não para Caderno de Campo",
		"Fonte": "4.3.1 - Taxa de participação de jovens e adultos na educação formal e não formal, nos últimos 12 meses, por sexo",
		"ODS": "4-Educação de qualidade"
	},
	{
		"TitleQuestion": "O agricultor faz controle do custo de produção?",
		"Code_R": "CONTROLECUSTO",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "4.3.1 - Taxa de participação de jovens e adultos na educação formal e não formal, nos últimos 12 meses, por sexo",
		"ODS": "4-Educação de qualidade"
	},
	{
		"TitleQuestion": "Se necessário, descreva a recomendação dada ao produtor para melhoria física do solo",
		"Code_R": "DESCEVERECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Se necessário, descreva a recomendação dada ao produtor para melhoria química do solo",
		"Code_R": "DESCEVERECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Selecione qual produto você quer fazer o registro de entradas ",
		"Code_R": "ENTRADAPRODUTO",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "4.3.1 - Taxa de participação de jovens e adultos na educação formal e não formal, nos últimos 12 meses, por sexo",
		"ODS": "4-Educação de qualidade"
	},
	{
		"TitleQuestion": "Se necessário, descreva a recomendação dada ao produtor para resolução do problema de alimentação",
		"Code_R": "DESCREVERECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Quais recomendações você gostaria de dar ao produtor sobre manejo animal?",
		"Code_R": "RECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Quais os manejos indicados para controle dessas daninhas? ",
		"Code_R": "RECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Faz ou pretende efetuar turismo rural na propriedade?",
		"Code_R": "FAZTURISMO",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não Atividade Turismo Rural",
		"Fonte": "8.9 - Até 2030, elaborar e implementar políticas para promover o turismo sustentável, que gera empregos e promove a cultura e os produtos locais",
		"ODS": "8-Trabalho decente e crescimento econômico"
	},
	{
		"TitleQuestion": "Qual a unidade de medida para a quantidade comprada?",
		"Code_R": "UNQUANTINSUMO",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Registro de entradas - unidade de medida da quantidade vendida",
		"Code_R": "UNQUANTPRODUTO",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Doenças e pragas - Nota do Agricultor",
		"Code_R": "NOTA",
		"Dimensão": "Produção",
		"Tema": "Manejo Vegetal",
		"Indicador": "Considera nota relacionada ao Manejo Vegetal",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Pós colheita - Nota do Agricultor",
		"Code_R": "NOTA",
		"Dimensão": "Produção",
		"Tema": "Manejo Vegetal",
		"Indicador": "Considera nota relacionada ao Manejo Vegetal",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Se necessário, descreva a recomendação dada ao produtor para melhorias relacionadas a pós colheita",
		"Code_R": "DESCREVERECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Selecione as culturas que você prestou o atendimento sobre pós colheita",
		"Code_R": "PRODUCAOVEGETAL",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Colheita - Nota do Agricultor",
		"Code_R": "NOTA",
		"Dimensão": "Produção",
		"Tema": "Manejo Vegetal",
		"Indicador": "Considera nota relacionada ao Manejo Vegetal",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Se necessário, descreva a recomendação dada ao produtor para melhorias relacionadas a colheita",
		"Code_R": "DESCREVERECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Selecione as culturas que você prestou o atendimento sobre colheita",
		"Code_R": "PRODUCAOVEGETAL",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "No caso do envio de conteúdo educativo da internet ou vídeo, insira o link do material enviado ao produtor:",
		"Code_R": "EVIDCONTEUDO",
		"Dimensão": "Social",
		"Tema": "Educação",
		"Indicador": "Realizou capacitações técnicas relacionadas à produção no último ano.",
		"Fonte": "4.3.1 - Taxa de participação de jovens e adultos na educação formal e não formal, nos últimos 12 meses, por sexo",
		"ODS": "4-Educação de qualidade"
	},
	{
		"TitleQuestion": "No caso do envio de conteúdo educativo da internet ou vídeo, insira o link do material enviado ao produtor:",
		"Code_R": "EVIDCONTEUDO",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "No caso do envio de conteúdo educativo da internet ou vídeo, insira o link do material enviado ao produtor:",
		"Code_R": "EVIDCONTEUDO",
		"Dimensão": "",
		"Tema": "",
		"Indicador": "",
		"Fonte": "",
		"ODS": ""
	},
	{
		"TitleQuestion": "Quais ações educacionais\/comunitárias o agricultor está envolvido?",
		"Code_R": "ACOESEDUCACIONAIS",
		"Dimensão": "Social",
		"Tema": "Educação",
		"Indicador": "Considera participa ou não de ações educacionais",
		"Fonte": "4.3.1 - Taxa de participação de jovens e adultos na educação formal e não formal, nos últimos 12 meses, por sexo",
		"ODS": "4-Educação de qualidade"
	},
	{
		"TitleQuestion": "O solo está compactado?",
		"Code_R": "SOLOCOMPACTADO",
		"Dimensão": "Produção",
		"Tema": "Qualidade do Solo",
		"Indicador": "Considera se o solo está ou não compactado",
		"Fonte": "15.3.1 - Proporção do território com solos degradados",
		"ODS": "15-Vida terrestre"
	},
	{
		"TitleQuestion": "Há sintomas de problemas nutricionais? Quais?",
		"Code_R": "DIAGNOSTVEGETALNUTRI",
		"Dimensão": "Produção",
		"Tema": "Sanidade Vegetal",
		"Indicador": "Presença ou não de sintomas nutricionais",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Piscicultura - Nota do Agricultor ",
		"Code_R": "NOTA",
		"Dimensão": "Produção",
		"Tema": "Piscicultura",
		"Indicador": "Considera nota relacionada ao Manejo da Piscicultura",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Selecione para qual tipo de turismo rural você prestou o atendimento",
		"Code_R": "TURISMOTIPO",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não Atividade Turismo Rural",
		"Fonte": "8.9 - Até 2030, elaborar e implementar políticas para promover o turismo sustentável, que gera empregos e promove a cultura e os produtos locais",
		"ODS": "8-Trabalho decente e crescimento econômico"
	},
	{
		"TitleQuestion": "Alimentação animal - Nota do Agricultor ",
		"Code_R": "NOTA",
		"Dimensão": "Produção",
		"Tema": "Manejo Animal",
		"Indicador": "Considera nota relacionada ao Manejo Animal",
		"Fonte": "",
		"ODS": ""
	},
	{
		"TitleQuestion": "Quais recomendações você gostaria de dar ao produtor sobre alimentação?",
		"Code_R": "RECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "O produtor faz compostagem do lixo doméstico?",
		"Code_R": "COMPOSTAGEM",
		"Dimensão": "Ambiental",
		"Tema": "Destino de Resíduos",
		"Indicador": "Considera fazer ou não acesso Compostagem",
		"Fonte": "6-3-2: Proporção de corpos hídricos com boa qualidade ambiental ",
		"ODS": "6-Água potável e saneamento"
	},
	{
		"TitleQuestion": "Se necessário, descreva a recomendação dada ao produtor para melhorias relacionadas à atividade ",
		"Code_R": "DESCREVERECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Selecione sobre o que você prestou o atendimento para qualidade de bacias hidrográficas",
		"Code_R": "QUALIDADEBACIA",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Tecnologia, equipamentos e maquinários - Nota do agricultor",
		"Code_R": "NOTA",
		"Dimensão": "Social",
		"Tema": "Tecnologia",
		"Indicador": "Considera nota relacionada ao acesso a Tecnologia",
		"Fonte": "9-c-1 - Proporção da população coberta por rede móvel, por tipo de tecnologia ",
		"ODS": "9-Indústria, Inovação e Infraestrutura"
	},
	{
		"TitleQuestion": "Selecione sobre o que você prestou o atendimento para tecnologia, equipamentos e maquinários",
		"Code_R": "TECNOLOGIA",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Quais recomendações você gostaria de dar ao produtor sobre a gestão financeira?",
		"Code_R": "RECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Selecione sobre que você prestou o atendimento para gestão financeira",
		"Code_R": "GESTAOFIN",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Se necessário, descreva a recomendação dada ao produtor para melhorias relacionadas à produção",
		"Code_R": "DESCREVERECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Quantas horas de mão de obra externa são contratadas por ano? (Horas\/ano)",
		"Code_R": "MAODEOBRAHORASANO",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Você deseja reportar alguma inadequação na alimentação efetuada pelo produtor?",
		"Code_R": "INAD",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Das mulheres que moram na mesma casa, quantas trabalham na atividade agrícola?",
		"Code_R": "MULHERESNAATIVIDADE",
		"Dimensão": "Social",
		"Tema": "Inclusão",
		"Indicador": "Participação de mulheres na produção",
		"Fonte": "5-5-2: Proporção de mulheres em posições gerenciais ",
		"ODS": "5-Igualdade de Gênero"
	},
	{
		"TitleQuestion": "Você deseja reportar alguma inadequação no manejo animal efetuado pelo produtor?",
		"Code_R": "INAD",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Sanidade animal - Nota do agricultor",
		"Code_R": "NOTA",
		"Dimensão": "Produção",
		"Tema": "Manejo Animal",
		"Indicador": "Considera nota relacionada ao Manejo Animal",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Daninhas - Nota agricultor",
		"Code_R": "NOTA",
		"Dimensão": "Produção",
		"Tema": "Manejo Vegetal",
		"Indicador": "Considera nota relacionada ao Manejo Vegetal",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Selecione as culturas que você prestou o atendimento sobre plantas daninhas",
		"Code_R": "PRODUCAOVEGETAL",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Selecione as culturas que você prestou o atendimento sobre doenças e pragas",
		"Code_R": "PRODUCAOVEGETAL",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Você deseja reportar alguma inadequação na adubação efetuada pelo agricultor?",
		"Code_R": "INAD",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Selecione as culturas que você prestou o atendimento sobre irrigação",
		"Code_R": "PRODUCAOVEGETAL",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Selecione as culturas que você prestou o atendimento sobre adubação",
		"Code_R": "PRODUCAOVEGETAL",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Selecione as culturas que você prestou o atendimento sobre correção de solo",
		"Code_R": "PRODUCAOVEGETAL",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Selecione as culturas que você prestou o atendimento sobre preparo de solo",
		"Code_R": "PRODUCAOVEGETAL",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Selecione as culturas que você prestou o atendimento sobre manejo cultural",
		"Code_R": "PRODUCAOVEGETAL",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Quantas pessoas são contratadas como mão de obra externa por ano?",
		"Code_R": "NUMPESSOASMAODEOBRA",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "O produtor realiza alguma prática de proteção às nascentes e fontes de água da propriedade?",
		"Code_R": "PROTECAOFONTEAGUA",
		"Dimensão": "Ambiental",
		"Tema": "Proteção a biodiversidade e corpos dágua",
		"Indicador": "Considerar se efetua ou não",
		"Fonte": "6-3-2: Proporção de corpos hídricos com boa qualidade ambiental ",
		"ODS": "6-Água potável e saneamento"
	},
	{
		"TitleQuestion": "Gestão Financeira - Nota do Agricultor",
		"Code_R": "NOTA",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera nota relacionada ao acesso a Gestão",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Qual o destino dado aos restos de culturais?",
		"Code_R": "RESTOSDE CULTURA",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Você deseja reportar alguma inadequação na correção do solo efetuado pelo agricultor? Em quais práticas de  correção do solo foi observado problemas?",
		"Code_R": "INAD",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Registro de contratação de mão de obra - Valor gasto com a mão de obra contratada (R$\/mês)",
		"Code_R": "MAODEOBRAVALORHORA",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Registro de entradas -  Quantidade vendida",
		"Code_R": "ENTRADAVALOR",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "4.3.1 - Taxa de participação de jovens e adultos na educação formal e não formal, nos últimos 12 meses, por sexo",
		"ODS": "4-Educação de qualidade"
	},
	{
		"TitleQuestion": "Registro de entradas - Data da venda",
		"Code_R": "DATAENTRADA",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "4.3.1 - Taxa de participação de jovens e adultos na educação formal e não formal, nos últimos 12 meses, por sexo",
		"ODS": "4-Educação de qualidade"
	},
	{
		"TitleQuestion": "Registro de entradas -  Valor recebido pela venda (R$)",
		"Code_R": "ENTRADAQUANT",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "4.3.1 - Taxa de participação de jovens e adultos na educação formal e não formal, nos últimos 12 meses, por sexo",
		"ODS": "4-Educação de qualidade"
	},
	{
		"TitleQuestion": "Qualidade da Bacia hidrográfica - Nota do Agricultor",
		"Code_R": "NOTA",
		"Dimensão": "Ambiental",
		"Tema": "Proteção a biodiversidade e corpos dágua",
		"Indicador": "Considera nota relacionada a qualidade da bacia",
		"Fonte": "6-3-2: Proporção de corpos hídricos com boa qualidade ambiental ",
		"ODS": "6-Água potável e saneamento"
	},
	{
		"TitleQuestion": "Turismo Rural - Nota do Agricultor",
		"Code_R": "NOTA",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera nota relacionada ao Turismo Rural",
		"Fonte": "8.9 - Até 2030, elaborar e implementar políticas para promover o turismo sustentável, que gera empregos e promove a cultura e os produtos locais",
		"ODS": "8-Trabalho decente e crescimento econômico"
	},
	{
		"TitleQuestion": "Manejo Animal - Nota do Agricultor",
		"Code_R": "NOTA",
		"Dimensão": "Produção",
		"Tema": "Manejo Animal",
		"Indicador": "Considera nota relacionada ao Manejo Animal",
		"Fonte": "2.4.1 - Proporção da área agrícola sob agricultura produtiva e sustentável",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Irrigação - Nota do Agricultor",
		"Code_R": "NOTA",
		"Dimensão": "Produção",
		"Tema": "Manejo Vegetal",
		"Indicador": "Considera nota relacionada ao Manejo Vegetal",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Correção do Solo - Nota do Agricultor",
		"Code_R": "NOTA",
		"Dimensão": "Produção",
		"Tema": "Manejo Vegetal",
		"Indicador": "Considera nota relacionada ao Manejo Vegetal",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Adubação - Nota do Agricultor",
		"Code_R": "NOTA",
		"Dimensão": "Produção",
		"Tema": "Manejo Vegetal",
		"Indicador": "Considera nota relacionada ao Manejo Vegetal",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Preparo do Solo - Nota do Agricultor",
		"Code_R": "NOTA",
		"Dimensão": "Produção",
		"Tema": "Manejo Vegetal",
		"Indicador": "Considera nota relacionada ao Manejo Vegetal",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Manejo Cultural - Nota do Agricultor",
		"Code_R": "NOTA",
		"Dimensão": "Produção",
		"Tema": "Manejo Vegetal",
		"Indicador": "Considera nota relacionada ao Manejo Vegetal",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Caso utiliza softwares e aplicativos, quais?",
		"Code_R": "SOFTWARE",
		"Dimensão": "Social",
		"Tema": "Tecnologia",
		"Indicador": "Considera ter ou não acesso a tecnologia",
		"Fonte": "9-c-1 - Proporção da população coberta por rede móvel, por tipo de tecnologia ",
		"ODS": "9-Indústria, Inovação e Infraestrutura"
	},
	{
		"TitleQuestion": "Quais atividades desempenhadas pelos jovens que trabalham na agricultura?",
		"Code_R": "JOVENSATIVIDADES",
		"Dimensão": "Social",
		"Tema": "Inclusão",
		"Indicador": "Participação de jovens na produção",
		"Fonte": "8-6-1 - Percentagem de jovens (15-24) que não estão na força de trabalho (ocupados e não ocupados), não são estudantes e nem estão em treinamento para o trabalho ",
		"ODS": "8-Trabalho decente e crescimento econômico"
	},
	{
		"TitleQuestion": "Das pessoas que moram na mesma casa, quantas são mulheres?",
		"Code_R": "MULHERESNACASA",
		"Dimensão": "Social",
		"Tema": "Inclusão",
		"Indicador": "Participação de mulheres na produção",
		"Fonte": "5-5-2: Proporção de mulheres em posições gerenciais ",
		"ODS": "5-Igualdade de Gênero"
	},
	{
		"TitleQuestion": "Quantos filhos trabalham na agricultura?",
		"Code_R": "JOVENSNAATIVIDADE",
		"Dimensão": "Social",
		"Tema": "Inclusão",
		"Indicador": "Participação de jovens na produção",
		"Fonte": "8-6-1 - Percentagem de jovens (15-24) que não estão na força de trabalho (ocupados e não ocupados), não são estudantes e nem estão em treinamento para o trabalho ",
		"ODS": "8-Trabalho decente e crescimento econômico"
	},
	{
		"TitleQuestion": "Autorização do Produtor - ManejeBem e parceiros",
		"Code_R": "EVIDACEITE",
		"Dimensão": "Social",
		"Tema": "Tecnologia",
		"Indicador": "Considera ter ou não acesso a tecnologia",
		"Fonte": "9-c-1 - Proporção da população coberta por rede móvel, por tipo de tecnologia ",
		"ODS": "9-Indústria, Inovação e Infraestrutura"
	},
	{
		"TitleQuestion": "Possui algum sistema de Gestão Ambiental implantado (planejamento de melhorias, aplicação de novas tecnologias, não conformidades, ações corretivas e preventivas)? Se sim, qual?",
		"Code_R": "TECAMBIENTAL",
		"Dimensão": "Ambiental",
		"Tema": "Proteção a biodiversidade e corpos dágua",
		"Indicador": "Considerar se efetua ou não",
		"Fonte": "6-3-2: Proporção de corpos hídricos com boa qualidade ambiental ",
		"ODS": "6-Água potável e saneamento"
	},
	{
		"TitleQuestion": "Se necessário, descreva a recomendação dada ao produtor para melhorias relacionadas à atividade de piscicultura",
		"Code_R": "DESCREVERECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Se necessário, descreva a recomendação dada ao produtor para melhorias relacionadas a Tecnologias e Maquinários",
		"Code_R": "DESCREVERECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Descreva a recomendação dada ao produtor para melhorias relacionadas ao Turismo Rural",
		"Code_R": "DESCREVERECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Se necessário, descreva a recomendação dada ao produtor para melhorias relacionadas à Gestão",
		"Code_R": "DESCREVERECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Qual o custo total com mão de obra externa por ano (R$)? ",
		"Code_R": "CUSTOMAODEOBRA",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "4.3.1 - Taxa de participação de jovens e adultos na educação formal e não formal, nos últimos 12 meses, por sexo",
		"ODS": "4-Educação de qualidade"
	},
	{
		"TitleQuestion": "Qual o gasto com agrotóxicos por ano? (R$)",
		"Code_R": "GASTOAGROTOXICOS",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "",
		"ODS": ""
	},
	{
		"TitleQuestion": "Qual o gasto total com insumos por ano? (R$)",
		"Code_R": "GASTOINSUMOS",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "",
		"ODS": ""
	},
	{
		"TitleQuestion": "Quais insumos utilizados para a produção vegetal?",
		"Code_R": "INSUMOS",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Registro de contratação de mão de obra - Horas trabalhadas por mês",
		"Code_R": "MAODEOBRAHORAS",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Registro de contratação de mão de obra - Motivo da contratação",
		"Code_R": "MOTIVOMAODEOBRA",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Registro de contratação de mão de obra - Data da contratação",
		"Code_R": "DATASAIDA",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "4.3.1 - Taxa de participação de jovens e adultos na educação formal e não formal, nos últimos 12 meses, por sexo",
		"ODS": "4-Educação de qualidade"
	},
	{
		"TitleQuestion": "Valor total gasto na compra do insumo selecionado (R$)",
		"Code_R": "GASTOINSUMO",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "",
		"ODS": ""
	},
	{
		"TitleQuestion": "Quantidade comprada",
		"Code_R": "QUANTINSUMO",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Qual insumo foi adquirido pelo produtor?",
		"Code_R": "TIPOINSUMO",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Registro de compra de insumos agrícolas - Data da compra ",
		"Code_R": "DATASAIDA",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "4.3.1 - Taxa de participação de jovens e adultos na educação formal e não formal, nos últimos 12 meses, por sexo",
		"ODS": "4-Educação de qualidade"
	},
	{
		"TitleQuestion": "Possui área de reserva legal na propriedade? ",
		"Code_R": "AREARESERVALEGAL",
		"Dimensão": "Ambiental",
		"Tema": "Cobertura vegetal",
		"Indicador": "Considerar se tem ou não área  reserva legal na propriedade",
		"Fonte": "15.1.2-Proporção de sítios importantes para a biodiversidade terrestre e de água doce cobertos por áreas protegidas, por tipo de ecossistema",
		"ODS": "15-Vida terrestre"
	},
	{
		"TitleQuestion": "Possui área de preservação permanente na propriedade? ",
		"Code_R": "AREAPRESERVACAOPERMANENTE",
		"Dimensão": "Ambiental",
		"Tema": "Cobertura vegetal",
		"Indicador": "Considerar se tem ou não área de preservação permanente na propriedade",
		"Fonte": "15.1.2-Proporção de sítios importantes para a biodiversidade terrestre e de água doce cobertos por áreas protegidas, por tipo de ecossistema",
		"ODS": "15-Vida terrestre"
	},
	{
		"TitleQuestion": "Efetua acompanhamento da qualidade da água (análise de poluentes)? ",
		"Code_R": "ANALISEAGUA",
		"Dimensão": "Ambiental",
		"Tema": "Proteção a biodiversidade e corpos dágua",
		"Indicador": "Considerar se faz ou não análise qualidade água",
		"Fonte": "6-3-2: Proporção de corpos hídricos com boa qualidade ambiental ",
		"ODS": "6-Água potável e saneamento"
	},
	{
		"TitleQuestion": "Possui fonte de água natural na propriedade? ",
		"Code_R": "FONTENATURAL",
		"Dimensão": "Ambiental",
		"Tema": "Proteção a biodiversidade e corpos dágua",
		"Indicador": "Considerar se tem ou não fonte",
		"Fonte": "",
		"ODS": ""
	},
	{
		"TitleQuestion": "Efetua atividades de restauração ecológica de matas ciliares, como por exemplo, plantio de árvores nativas? ",
		"Code_R": "MATACILIAR",
		"Dimensão": "Ambiental",
		"Tema": "Proteção a biodiversidade e corpos dágua",
		"Indicador": "Considerar se efetua ou não proteção ambiental",
		"Fonte": "6-3-2: Proporção de corpos hídricos com boa qualidade ambiental ",
		"ODS": "6-Água potável e saneamento"
	},
	{
		"TitleQuestion": "É realizado o acompanhamento dos parâmetros de qualidade de água dos viveiros?",
		"Code_R": "PISCICULTURAPARAMETROS",
		"Dimensão": "Produção",
		"Tema": "Piscicultura",
		"Indicador": "Considera se acompanha ou não parâmetros",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Qual o sistema de piscicultura utilizado na propriedade?",
		"Code_R": "PISCICULTURASISTEMA\n",
		"Dimensão": "Produção",
		"Tema": "Piscicultura",
		"Indicador": "Considera o sistema",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "É realizada a piscicultura integrada com a atividade agrícola na propriedade?",
		"Code_R": "PISCICULTURATIPO",
		"Dimensão": "Produção",
		"Tema": "Piscicultura",
		"Indicador": "Considera o sistema",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Quais os impactos positivos relacionados à atividade turística? ",
		"Code_R": "TURISMOPOSITIVO",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não Atividade Turismo Rural",
		"Fonte": "8.9 - Até 2030, elaborar e implementar políticas para promover o turismo sustentável, que gera empregos e promove a cultura e os produtos locais",
		"ODS": "8-Trabalho decente e crescimento econômico"
	},
	{
		"TitleQuestion": "Quais os impactos negativos relacionados à atividade turística? ",
		"Code_R": "TURISMONEGATIVO",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não Atividade Turismo Rural",
		"Fonte": "8.9 - Até 2030, elaborar e implementar políticas para promover o turismo sustentável, que gera empregos e promove a cultura e os produtos locais",
		"ODS": "8-Trabalho decente e crescimento econômico"
	},
	{
		"TitleQuestion": "Se sim, quais atividades turísticas são efetuadas na propriedade? ",
		"Code_R": "TURISMO",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não Atividade Turismo Rural",
		"Fonte": "8.9 - Até 2030, elaborar e implementar políticas para promover o turismo sustentável, que gera empregos e promove a cultura e os produtos locais",
		"ODS": "8-Trabalho decente e crescimento econômico"
	},
	{
		"TitleQuestion": "Faz alguma ação relacionada ao turismo rural na propriedade?",
		"Code_R": "FAZTURISMO",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não Atividade Turismo Rural",
		"Fonte": "8.9 - Até 2030, elaborar e implementar políticas para promover o turismo sustentável, que gera empregos e promove a cultura e os produtos locais",
		"ODS": "8-Trabalho decente e crescimento econômico"
	},
	{
		"TitleQuestion": "Quais equipamentos de proteção individual utiliza durante o trabalho agrícola? ",
		"Code_R": "EPI",
		"Dimensão": "Social",
		"Tema": "Saúde",
		"Indicador": "Considera ter ou não acesso a EPI",
		"Fonte": "",
		"ODS": ""
	},
	{
		"TitleQuestion": "Possui acesso à maquinário agrícola? Quais? ",
		"Code_R": "MAQUINARIO",
		"Dimensão": "Social",
		"Tema": "Tecnologia",
		"Indicador": "Considera ter ou não acesso a tecnologia",
		"Fonte": "9-c-1 - Proporção da população coberta por rede móvel, por tipo de tecnologia ",
		"ODS": "9-Indústria, Inovação e Infraestrutura"
	},
	{
		"TitleQuestion": "Qual o valor total gasto na compra do agrotóxico (R$) por mês?",
		"Code_R": "GASTOAGROTOXICOS",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "",
		"ODS": ""
	},
	{
		"TitleQuestion": "Qual a quantidade (kg) de agrotóxicos é utilizado na propriedade por mês?",
		"Code_R": "QUANTIAAGROTOXICOS",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Qual o custo total da produção por ano? (R$)",
		"Code_R": "CUSTOPRODUCAO",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "4.3.1 - Taxa de participação de jovens e adultos na educação formal e não formal, nos últimos 12 meses, por sexo",
		"ODS": "4-Educação de qualidade"
	},
	{
		"TitleQuestion": "O produtor efetua controle do fluxo de caixa? ",
		"Code_R": "CONTROLECAIXA",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "4.3.1 - Taxa de participação de jovens e adultos na educação formal e não formal, nos últimos 12 meses, por sexo",
		"ODS": "4-Educação de qualidade"
	},
	{
		"TitleQuestion": "De 0 a 5, qual o nível de satisfação do agricultor com a assistência técnica que ele acessa? ",
		"Code_R": "NOTA",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera nota relacionana a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Na casa, existe algum morador com 16 anos ou mais que não possui um emprego?",
		"Code_R": "DEMPREGO",
		"Dimensão": "Social",
		"Tema": "Emprego",
		"Indicador": "Varia de acordo com o número de desempregados",
		"Fonte": "8-5-2: Taxa de desocupação, por sexo, idade e pessoas com deficiência ",
		"ODS": "8-Trabalho decente e crescimento econômico"
	},
	{
		"TitleQuestion": "Acesso à banheiro ",
		"Code_R": "ACESSOBANHEIRO",
		"Dimensão": "Ambiental",
		"Tema": "Saneamento",
		"Indicador": "Tipo de instalação sanitária variando do insustentável (sem nenhum tipo de tratamento) ao sustentável (com tratamento)",
		"Fonte": "6-2-1 - Proporção da população que utiliza (a) serviços de saneamento gerenciados de forma segura e (b) instalações para lavagem das mãos com água e sabão ",
		"ODS": "6-Água potável e saneamento"
	},
	{
		"TitleQuestion": "O agricultor acessa os serviços de assistência técnica a cada quanto tempo? ",
		"Code_R": "FREQUENCIA",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Utiliza serviços de assistência técnica agrícola? Qual tipo?",
		"Code_R": "ASSISTECTIPO",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Como é feita a gestão da propriedade?",
		"Code_R": "GESTAOFIN",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Quais tecnologias utilizadas no dia-a-dia? ",
		"Code_R": "TECNODIA",
		"Dimensão": "Social",
		"Tema": "Tecnologia",
		"Indicador": "Considera ter ou não acesso a tecnologia",
		"Fonte": "9-c-1 - Proporção da população coberta por rede móvel, por tipo de tecnologia ",
		"ODS": "9-Indústria, Inovação e Infraestrutura"
	},
	{
		"TitleQuestion": "Possui acesso à internet?",
		"Code_R": "INTERNET",
		"Dimensão": "Social",
		"Tema": "Tecnologia",
		"Indicador": "Considera ter ou não acesso a tecnologia",
		"Fonte": "17-8-1 - Proporção de indivíduos que utilizam a Internet ",
		"ODS": "17-Parcerias e meios de implementação"
	},
	{
		"TitleQuestion": "Utiliza mão de obra externa?",
		"Code_R": "USOMAODEOBRAEXTERNA",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera fazer ou não para Controle",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Utiliza mão de obra externa?",
		"Code_R": "USOMAODEOBRAEXTERNA",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não mão de obra externa",
		"Fonte": "",
		"ODS": ""
	},
	{
		"TitleQuestion": "Com que frequência realiza a adubação?",
		"Code_R": "FREQUENCIA",
		"Dimensão": "Produção",
		"Tema": "Manejo Vegetal",
		"Indicador": "Considera se efetua ou não adubação",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Destino dos dejetos animais ",
		"Code_R": "DEJETOS",
		"Dimensão": "Ambiental",
		"Tema": "Destino de Resíduos",
		"Indicador": "Considera dá ou não destino correto aos dejetos",
		"Fonte": "6-3-2: Proporção de corpos hídricos com boa qualidade ambiental ",
		"ODS": "6-Água potável e saneamento"
	},
	{
		"TitleQuestion": "Se necessário, descreva a recomendação dada ao produtor para resolução do problema de manejo ",
		"Code_R": "DESCREVERECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Quais os manejos efetuados na propriedade para a produção animal? ",
		"Code_R": "MANEJOS",
		"Dimensão": "Produção",
		"Tema": "Manejo Animal",
		"Indicador": "Considerar tipo de manejo animal",
		"Fonte": "2.4.1 - Proporção da área agrícola sob agricultura produtiva e sustentável",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Se necessário, descreva a recomendação dada ao produtor para resolução do problema sanitário",
		"Code_R": "DESCREVERECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Quais sintomas foram observados? ",
		"Code_R": "DIAGOSTICOANIMAL",
		"Dimensão": "Produção",
		"Tema": "Sanidade Animal",
		"Indicador": "Presença ou não de doenças",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Problemas sanitários observados nos animais",
		"Code_R": "SANIDADEANIMAL",
		"Dimensão": "Produção",
		"Tema": "Sanidade Animal",
		"Indicador": "Presença ou não de doenças",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Se julgar necessário, descreva a recomendação de manejo de daninhas efetuadas ao agricultor",
		"Code_R": "DESCREVERECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Se julgar necessário, descreva a recomendação de manejo de doenças e pragas efetuadas ao agricultor",
		"Code_R": "DESCREVERECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Quais os manejos indicados para controle de doenças e pragas vegetais? ",
		"Code_R": "RECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Quais os manejos efetuados para controle de doenças e pragas vegetais? ",
		"Code_R": "MANEJOS",
		"Dimensão": "Ambiental",
		"Tema": "Manejo",
		"Indicador": "Manejo sustentável ou não (Corte e queima, Convencional com\/sem orientação técnica, Transição agroecológica e Agroecológico)",
		"Fonte": "2.4.1 - Proporção da área agrícola sob agricultura produtiva e sustentável",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Quais as principais doenças observadas? ",
		"Code_R": "DOENCAS",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Quais as principais pragas observadas? ",
		"Code_R": "PRAGAS",
		"Dimensão": "Ambiental",
		"Tema": "Manejo",
		"Indicador": "Manejo sustentável ou não (Corte e queima, Convencional com\/sem orientação técnica, Transição agroecológica e Agroecológico)",
		"Fonte": "2.4.1 - Proporção da área agrícola sob agricultura produtiva e sustentável",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Se necessário, descreva a recomendação de irrigação efetuada ao agricultor",
		"Code_R": "DESCREVERECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Você deseja reportar alguma inadequação na irrigação efetuada pelo agricultor? ",
		"Code_R": "INAD",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Se julgar necessário, descreva a recomendação para adubação efetuada ao agricultor",
		"Code_R": "DESCREVERECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Quais recomendações de adubação foram efetuadas para o agricultor?",
		"Code_R": "RECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Se necessário, descreva a recomendação de correção efetuada ao agricultor",
		"Code_R": "DESCREVERECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Quais recomendações de correção foram efetuadas para o agricultor?",
		"Code_R": "RECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Se necessário, descreva a recomendação para o preparo do solo efetuada ao agricultor",
		"Code_R": "DESCREVERECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Quais recomendações de preparo do solo foram efetuadas para o agricultor?",
		"Code_R": "RECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Você deseja reportar alguma inadequação no preparo do solo efetuado pelo agricultor? ",
		"Code_R": "INAD",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Se julgar necessário, descreva o manejo cultural recomendado ao agricultor",
		"Code_R": "DESCREVERECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Quais recomendações de manejo cultural foram dadas ao agricultor?",
		"Code_R": "RECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Você deseja reportar alguma inadequação no manejo cultural efetuado pelo agricultor? ",
		"Code_R": "INAD",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Instalações sanitárias ",
		"Code_R": "TIPOSANIT",
		"Dimensão": "Ambiental",
		"Tema": "Saneamento",
		"Indicador": "Tipo de instalação sanitária variando do insustentável (sem nenhum tipo de tratamento) ao sustentável (com tratamento)",
		"Fonte": "6-2-1 - Proporção da população que utiliza (a) serviços de saneamento gerenciados de forma segura e (b) instalações para lavagem das mãos com água e sabão ",
		"ODS": "6-Água potável e saneamento"
	},
	{
		"TitleQuestion": "Na sua propriedade possui serviços de saneamento básico oferecidos pela prefeitura?",
		"Code_R": "SANEAMENTO",
		"Dimensão": "Ambiental",
		"Tema": "Saneamento",
		"Indicador": "Tipo de instalação sanitária variando do insustentável (sem nenhum tipo de tratamento) ao sustentável (com tratamento)",
		"Fonte": "6-2-1 - Proporção da população que utiliza (a) serviços de saneamento gerenciados de forma segura e (b) instalações para lavagem das mãos com água e sabão ",
		"ODS": "6-Água potável e saneamento"
	},
	{
		"TitleQuestion": "O agricultor está envolvido em ações educacionais\/comunitárias? ",
		"Code_R": "ACOESEDUCACIONAIS",
		"Dimensão": "Social",
		"Tema": "Educação",
		"Indicador": "Considera participa ou não de ações educacionais",
		"Fonte": "4.3.1 - Taxa de participação de jovens e adultos na educação formal e não formal, nos últimos 12 meses, por sexo",
		"ODS": "4-Educação de qualidade"
	},
	{
		"TitleQuestion": "O agricultor recebe algum benefício do governo? ",
		"Code_R": "BENEFICGOV",
		"Dimensão": "Econômica",
		"Tema": "Renda Familiar",
		"Indicador": "Considera ter ou não de benefícios do governo",
		"Fonte": "1-1-1 - Proporção da população vivendo abaixo da linha de pobreza internacional, por sexo, idade, condição perante o trabalho e localização geográfica (urbano\/rural) ",
		"ODS": "1-ERRADICAÇÃO DA POBREZA"
	},
	{
		"TitleQuestion": "O agricultor possui algum tipo de renda não monetária (troca de alimentos e serviços entre agricultores e propriedades)?  Qual? ",
		"Code_R": "RENDANAOMONETARIA",
		"Dimensão": "Econômica",
		"Tema": "Renda Familiar",
		"Indicador": "Calculado (Preço médio * produção total) \/ 12 e % em relação ao salario mínimo ideal do DIEESE do ano anterior)",
		"Fonte": "1-1-1 - Proporção da população vivendo abaixo da linha de pobreza internacional, por sexo, idade, condição perante o trabalho e localização geográfica (urbano\/rural) ",
		"ODS": "1-ERRADICAÇÃO DA POBREZA"
	},
	{
		"TitleQuestion": "Quais atividades desempenhadas pelas mulheres que trabalham na agricultura? ",
		"Code_R": "MULHERESATIVIDADES",
		"Dimensão": "Social",
		"Tema": "Inclusão",
		"Indicador": "Participação de mulheres na produção",
		"Fonte": "5-5-2: Proporção de mulheres em posições gerenciais ",
		"ODS": "5-Igualdade de Gênero"
	},
	{
		"TitleQuestion": "Se a mulher trabalhar na roça, ela está sozinha ou tem a ajuda do marido ou filhos?",
		"Code_R": "MULHERESAJUDA",
		"Dimensão": "Social",
		"Tema": "Inclusão",
		"Indicador": "Participação de mulheres na produção",
		"Fonte": "5-5-2: Proporção de mulheres em posições gerenciais ",
		"ODS": "5-Igualdade de Gênero"
	},
	{
		"TitleQuestion": "A esposa do agricultor trabalha na roça? ",
		"Code_R": "MULHERESNAATIVIDADE",
		"Dimensão": "Social",
		"Tema": "Inclusão",
		"Indicador": "Participação de mulheres na produção",
		"Fonte": "5-5-2: Proporção de mulheres em posições gerenciais ",
		"ODS": "5-Igualdade de Gênero"
	},
	{
		"TitleQuestion": "Dos filhos que NÃO trabalham na roça, por que não trabalham na roça?",
		"Code_R": "JOVENSFORADAATIVIDADE",
		"Dimensão": "Social",
		"Tema": "Inclusão",
		"Indicador": "Participação de jovens na produção",
		"Fonte": "8-6-1 - Percentagem de jovens (15-24) que não estão na força de trabalho (ocupados e não ocupados), não são estudantes e nem estão em treinamento para o trabalho ",
		"ODS": "8-Trabalho decente e crescimento econômico"
	},
	{
		"TitleQuestion": "Quantos filhos o agricultor possui ?",
		"Code_R": "JOVENSNACASA",
		"Dimensão": "Social",
		"Tema": "Inclusão",
		"Indicador": "Participação de jovens na produção",
		"Fonte": "8-6-1 - Percentagem de jovens (15-24) que não estão na força de trabalho (ocupados e não ocupados), não são estudantes e nem estão em treinamento para o trabalho ",
		"ODS": "8-Trabalho decente e crescimento econômico"
	},
	{
		"TitleQuestion": "Das pessoas que moram na mesma casa, quantas são jovens (menores de 16 anos) ? ",
		"Code_R": "JOVENSNACASA",
		"Dimensão": "Social",
		"Tema": "Inclusão",
		"Indicador": "Participação de jovens na produção",
		"Fonte": "8-6-1 - Percentagem de jovens (15-24) que não estão na força de trabalho (ocupados e não ocupados), não são estudantes e nem estão em treinamento para o trabalho ",
		"ODS": "8-Trabalho decente e crescimento econômico"
	},
	{
		"TitleQuestion": "Qual a renda bruta familiar TOTAL",
		"Code_R": "RENDABRUTATOTAL",
		"Dimensão": "Econômica",
		"Tema": "Renda Familiar",
		"Indicador": "Calculado (Preço médio * produção total) \/ 12 e % em relação ao salario mínimo ideal do DIEESE do ano anterior)",
		"Fonte": "1-1-1 - Proporção da população vivendo abaixo da linha de pobreza internacional, por sexo, idade, condição perante o trabalho e localização geográfica (urbano\/rural) ",
		"ODS": "1-ERRADICAÇÃO DA POBREZA"
	},
	{
		"TitleQuestion": "Qual a escolaridade do agricultor?",
		"Code_R": "ESCOLARIDADE",
		"Dimensão": "Social",
		"Tema": "Educação",
		"Indicador": "Varia de não alfabetizado a nivel superior completo. No caso de curso técnico considerar como ensimo médio.",
		"Fonte": "4.5 - Até 2030, eliminar as disparidades de gênero na educação e garantir a igualdade de acesso a todos os níveis de educação e formação profissional para os mais vulneráveis, incluindo as pessoas com deficiência, povos indígenas e as crianças em situação de vulnerabilidade",
		"ODS": "4-Educação de qualidade"
	},
	{
		"TitleQuestion": "Qual a agricultura praticada",
		"Code_R": "AGRICULTURATIPO",
		"Dimensão": "Ambiental",
		"Tema": "Manejo",
		"Indicador": "Varia entre Agroecológica; Agroflorestal; Biodinâmica; Convencional; Convencional sem agrotóxico; Orgânica",
		"Fonte": "2.4.1 - Proporção da área agrícola sob agricultura produtiva e sustentável",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Qual recomendação para adubação do solo para o cultivo da cultura selecionada?",
		"Code_R": "RECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	},
	{
		"TitleQuestion": "Quais recomendações para o preparo do solo foram efetuadas para a cultura selecionada?",
		"Code_R": "RECOMEND",
		"Dimensão": "Econômica",
		"Tema": "Gestão do Empreendimento",
		"Indicador": "Considera ter ou não acesso a Assistência Técnica",
		"Fonte": "2-a-1 - Índice de orientação agrícola para a despesa pública ",
		"ODS": "2-Fome zero e agricultura sustentável"
	}
]

const odsIcons = [
	"https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-1.svg",
	"https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-2.svg",
	"https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-3.svg",
	"https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-4.svg",
	"https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-5.svg",
	"https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-6.svg",
	"https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-7.svg",
	"https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-8.svg",
	"https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-9.svg",
	"https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-10.svg",
	"https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-11.svg",
	"https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-12.svg",
	"https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-13.svg",
	"https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-14.svg",
	"https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-15.svg",
	"https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-16.svg",
	"https://brasil.un.org/profiles/undg_country/themes/custom/undg/images/SDGs/pt-br/SDG-17.svg",
]

export const ods = [...new Set(indicators.map(item => item.ODS))].map(ODS => ({
	title: ODS,
	indicators: [...new Set(indicators.filter(item => item.ODS === ODS).map(item => item.Fonte))].map(indicator => ({
		title: indicator,
		questions: [...new Set(indicators.filter(item => item.ODS === ODS && item.Fonte === indicator).map(item => item.Code_R))].map(code => {
			const question = indicators.find(item => item.ODS === ODS && item.Fonte === indicator && item.Code_R === code);
			return {
				title: question?.TitleQuestion,
				code
			}
		})
	}))
})).filter(item => item.title).map(item => ({
	...item,
	odsIndex: parseInt(item.title.split("-")[0]) - 1,
	icon: odsIcons[parseInt(item.title.split("-")[0]) - 1]
}));



